import * as ChargebeeActions from '../actions/chargebee-actions';
import { cAccountInfo } from '../shared/models/api/chargbeeprofile-api.model';

export interface State {
    cprofile: cAccountInfo;
    isLoaded: boolean;
}

export const initialState: State = {
    cprofile: undefined,
    isLoaded: false,
};

export function reducer(state = initialState, action: ChargebeeActions.All) {
    switch (action.type) {
        case ChargebeeActions.CHARGEBEE_GET:
            return Object.assign({}, state, { error: undefined, isLoaded: false });
        case ChargebeeActions.CHARGEBEE_SUCCESS:
            return Object.assign({}, state, {
                cprofile: action.payload.cprofile,
                isLoaded: true
            });
        case ChargebeeActions.CHARGEBEE_FAILURE:
            return Object.assign({}, state, {
                ...initialState,
                isLoaded: true
            });
        default:
            return state;
    }
}